export default "__VITE_ASSET__DQYfpRVA__"